// this.$store.state.inspeccion y this.$store.state.inspeccionExento
import { db, functions } from "@/firebase";
import {
  doc,
  query,
  collection,
  where,
  getDocs,
  serverTimestamp,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import localforage from "localforage";
import moment from "moment";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable"; // agrega doc.autoTable a jsPDF
import _ from "lodash";
import { colecciones, ruta } from "../constantes";

// INSPECCION
export const inspeccion = {
  objeto: class {
    constructor() {
      return {
        id: "",
        idSupervisor: "",
        idUsuario: "",
        idEmpresa: "",
        tipo: "",
        vehiculo: {
          id: "",
          idSoat: "",
          idTecnicoMecanica: "",
          idRevision: "",
          idCartaPropiedad: "",
          kilometraje: 0,
          imagenes: [],
        },
        conductor: {
          id: "",
          idLicencia: "",
          idExamen: "",
          idCapacitacion: "",
          idRevision: "",
        },
        ubicacion: {
          empresa: "",
          pais: "",
          departamento: "",
          ciudad: "",
          lineaNegocio: "",
          gps: {
            latitud: "",
            longitud: "",
          },
        },
        formato: {
          id: "",
          secciones: [],
        },
        resultado: "Pendiente",
        esRodamiento: true,
        declaracionVeracidad: false,
        registro: {
          tipo: "Online",
          filtro: moment().format("YYYY-MM-DD"),
          realizacion: {
            fecha: moment().format("YYYY-MM-DD"),
            hora: moment().format("hh:mm:ss A"),
          },
          creacion: serverTimestamp(),
          actualizacion: serverTimestamp(),
          sincronizacion: serverTimestamp(),
          estado: "Creado",
        },
      };
    }
  },
  funciones: {
    async crear(inspeccion, esEditar, modoSinConexion, coleccion) {
      const guardarLocal = async () => {
        inspeccion.registro.tipo = "Offline";
        const col = coleccion || colecciones.localforage.seguridadVial.inspecciones.registros;
        const inspecciones = await localforage.getItem(col);
        const lista = Array.isArray(inspecciones) ? inspecciones : [];
        if (esEditar) {
          const index = lista.findIndex((reg) => reg && reg.id === inspeccion.id);
          if (index !== -1) {
            lista[index] = inspeccion;
          } else {
            lista.push(inspeccion);
          }
          await localforage.setItem(col, lista);
        } else {
          const filtrados = lista.filter((reg) => reg && reg.id !== inspeccion.id);
          filtrados.push(inspeccion);
          await localforage.setItem(col, filtrados);
        }
      };

      if (modoSinConexion || !navigator.onLine) {
        await guardarLocal();
      } else {
        try {
          const escribirFirestore = setDoc(
            doc(
              db,
              coleccion
                ? coleccion
                : colecciones.firebase.seguridadVial.inspecciones.registros,
              inspeccion.id,
            ),
            inspeccion,
          );
          const timeoutPromise = new Promise((_, reject) =>
            setTimeout(() => reject(new Error("Timeout de red al guardar inspección")), 8000)
          );
          await Promise.race([escribirFirestore, timeoutPromise]);
        } catch (error) {
          console.warn("Falla o timeout al guardar inspección en línea. Guardando respaldo seguro en almacenamiento local:", error);
          await guardarLocal();
        }
      }
    },
    // El resultado que deciden los documentos del vehículo y del conductor; null si no lo deciden y manda el
    // formato. Lo usan la inspección de todos los días y la de auditoría que se hace en el momento
    resultadoPorDocumentos(inspeccion, tieneLicenciasVigentes) {
      const vehiculo = inspeccion.vehiculo;
      const conductor = inspeccion.conductor;
      if (
        !vehiculo.idSoat ||
        !vehiculo.idTecnicoMecanica ||
        !conductor.idLicencia ||
        (!conductor.idExamen && !tieneLicenciasVigentes && inspeccion.esRodamiento)
      ) {
        return "No Apto";
      }
      if (
        !conductor.idCapacitacion ||
        (vehiculo.idRevision && inspeccion.esRodamiento) ||
        (conductor.idRevision && inspeccion.esRodamiento)
      ) {
        return "Con Control Específico";
      }
      return null;
    },
    async eliminar(id, modoSinConexion) {
      if (modoSinConexion) {
        const registros = await localforage.getItem(
          colecciones.localforage.seguridadVial.inspecciones.registros,
        );
        const index = registros
          ? registros.findIndex((reg) => reg.id === id)
          : -1;
        if (index !== -1) {
          registros.splice(index, 1);
          await localforage.setItem(
            colecciones.localforage.seguridadVial.inspecciones.registros,
            registros,
          );
        }
      } else {
        await updateDoc(
          doc(
            db,
            colecciones.firebase.seguridadVial.inspecciones.registros,
            id,
          ),
          {
            "registro.estado": "Eliminado",
            "registro.actualizacion": serverTimestamp(),
          },
        );
      }
    },
    async obtener(id, modoSinConexion) {
      if (modoSinConexion) {
        const registros = await localforage.getItem(
          colecciones.localforage.seguridadVial.inspecciones.registros,
        );
        return registros ? registros.find((item) => item.id === id) : null;
      } else {
        const q = query(
          collection(
            db,
            colecciones.firebase.seguridadVial.inspecciones.registros,
          ),
          where("id", "==", id),
          where("registro.estado", "in", ["Creado", "Editado"]),
        );
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs.length > 0
          ? querySnapshot.docs[0].data()
          : null;
      }
    },
    async generarID() {
      const refInspeccion = doc(
        collection(
          db,
          colecciones.firebase.seguridadVial.inspecciones.registros,
        ),
      );
      return refInspeccion.id;
    },
    async generarInforme(inspeccion, usuario, descargar = true) {
      /* GENERAR IMAGEN DE MAPA Y OBTENER DIRECCIÓN APARTIR DE COORDENADAS */
      let mapa = null;
      let direccion = null;
      try {
        if (inspeccion.ubicacion && inspeccion.ubicacion.gps) {
          const { latitud, longitud } = inspeccion.ubicacion.gps;
          if (latitud && longitud) {
            const generarMapa = httpsCallable(
              functions,
              "generarMapaEstatico",
            );
            const result = await generarMapa({
              latitud: latitud,
              longitud: longitud,
            });
            mapa =
              result.data && result.data.imagen ? result.data.imagen : null;
            direccion =
              result.data && result.data.direccion
                ? result.data.direccion
                : null;
          }
        }
      } catch (error) {
        mapa = null;
        direccion = null;
      }

      /* VARIABLES DEL INFORME */
      const doc = new jsPDF("p", "mm", "letter", true);
      const width = doc.internal.pageSize.getWidth();
      const pageW = doc.internal.pageSize.getWidth();
      const pageH = doc.internal.pageSize.getHeight();
      const left = 15;
      const right = 15;
      const CONTENT_TOP_Y = 38;
      const cabecera = new Image();
      cabecera.src = require("@/assets/img/cabecera_informe.png");

      /* PROPIEDADES DEL INFORME */
      doc.setProperties({
        title: "Informe de Inspección / Seguridad Vial",
        subject: "RiskMann",
        author: "SOFU BIC S.A.S",
        creator: "RiskMann",
      });

      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);

      /* HELPERS */
      const imgCache = new Map();

      const crearCabeceraInforme = () => {
        doc.addImage(cabecera, "jpg", 15, 8, 15, 15, undefined, "FAST");
        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        doc.text(pageW / 2, 15, "INFORME DE INSPECCIÓN", {
          align: "center",
        });
      };

      const agregarPaginaConCabecera = () => {
        doc.addPage();
        crearCabeceraInforme();
        return CONTENT_TOP_Y;
      };

      const asegurarEspacio = (y, needed, top = 20, bottom = 20) => {
        if (y + needed > pageH - bottom) {
          return agregarPaginaConCabecera();
        }
        return y;
      };

      const blobToDataURL = (blob) =>
        new Promise((resolve, reject) => {
          const r = new FileReader();
          r.onload = () => resolve(r.result);
          r.onerror = reject;
          r.readAsDataURL(blob);
        });

      const dataUrlToJpegDataUrl = (dataUrl, quality = 0.9) =>
        new Promise((resolve, reject) => {
          const img = new Image();
          img.onload = () => {
            const canvas = document.createElement("canvas");
            canvas.width = img.naturalWidth;
            canvas.height = img.naturalHeight;
            const ctx = canvas.getContext("2d");

            // fondo blanco por si venía PNG con alpha
            ctx.fillStyle = "#fff";
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(img, 0, 0);

            resolve(canvas.toDataURL("image/jpeg", quality));
          };
          img.onerror = reject;
          img.src = dataUrl;
        });

      const getImageNaturalSize = (dataUrl) =>
        new Promise((resolve, reject) => {
          const img = new Image();
          img.onload = () =>
            resolve({ w: img.naturalWidth, h: img.naturalHeight });
          img.onerror = reject;
          img.src = dataUrl;
        });

      const fitIntoBox = (imgW, imgH, boxW, boxH) => {
        const r = Math.min(boxW / imgW, boxH / imgH);
        const w = imgW * r;
        const h = imgH * r;
        return { w, h, dx: (boxW - w) / 2, dy: (boxH - h) / 2 };
      };

      const fetchHttpsImageAsJpegDataUrl = async (url) => {
        if (!url) return null;
        if (imgCache.has(url)) return imgCache.get(url);

        const res = await fetch(url, { mode: "cors" });
        if (!res.ok) throw new Error(`HTTP ${res.status} al cargar imagen`);

        const blob = await res.blob();
        const dataUrl = await blobToDataURL(blob);
        const jpegDataUrl = await dataUrlToJpegDataUrl(dataUrl, 0.9);

        imgCache.set(url, jpegDataUrl);
        return jpegDataUrl;
      };

      const renderVehiculoImagenes = async (startY) => {
        // Título de sección
        startY = asegurarEspacio(startY, 14);
        doc.setFont("helvetica", "bold");
        doc.text(left, startY + 5, "IMÁGENES DEL VEHÍCULO");
        startY += 12;

        const imagenes = inspeccion?.vehiculo?.imagenes;

        // Si no hay imágenes
        if (!Array.isArray(imagenes) || imagenes.length === 0) {
          startY = asegurarEspacio(startY, 8);
          doc.setFont("helvetica", "normal");
          doc.text(
            left,
            startY,
            "No hay imágenes registradas para el vehículo inspeccionado.",
          );
          return startY + 10;
        }

        // Grid 2 columnas
        const gapX = 4;
        const gapY = 4;
        const cols = 2;
        const usableW = pageW - left - right;
        const cellW = (usableW - gapX) / cols;
        const cellH = 55;

        let y = startY;

        for (let i = 0; i < imagenes.length; i++) {
          const col = i % cols;
          const x = left + col * (cellW + gapX);

          // asegurar espacio para la fila completa
          if (col === 0) y = asegurarEspacio(y, cellH + gapY);

          try {
            const item = imagenes[i];
            const url =
              typeof item === "string" ? item : item?.url || item?.src;
            const jpegDataUrl = await fetchHttpsImageAsJpegDataUrl(url);
            if (!jpegDataUrl) throw new Error("URL inválida");
            const { w: iw, h: ih } = await getImageNaturalSize(jpegDataUrl);
            const fit = fitIntoBox(iw, ih, cellW, cellH);
            doc.addImage(
              jpegDataUrl,
              "JPEG",
              x + fit.dx,
              y + fit.dy,
              fit.w,
              fit.h,
              undefined,
              "FAST",
            );
          } catch (e) {
            doc.rect(x, y, cellW, cellH);
            doc.setFont("helvetica", "normal");
            doc.text(x + 2, y + 6, "No fue posible cargar esta imagen.");
          }

          if (col === cols - 1 || i === imagenes.length - 1) {
            y += cellH + gapY;
          }
        }

        return y;
      };

      const imprimirKV = (y, label, value, valueX = 42) => {
        doc.setFont("helvetica", "bold");
        doc.setFontSize(10);
        doc.text(left, y, label);
        doc.setFont("helvetica", "normal");
        doc.text(valueX, y, (value ?? "").toString());
      };

      const dibujarCheckbox = (doc, x, y, size, checked = false) => {
        doc.rect(x, y, size, size);
        if (checked) {
          doc.line(
            x + size * 0.2,
            y + size * 0.55,
            x + size * 0.42,
            y + size * 0.78,
          );
          doc.line(
            x + size * 0.42,
            y + size * 0.78,
            x + size * 0.82,
            y + size * 0.22,
          );
        }
      };

      /* DATOS DEL VEHÍCULO */
      crearCabeceraInforme();
      // TITULO
      const vehiculoIcon = new Image();
      vehiculoIcon.src = require("@/assets/img/icono_vehiculo.png");
      doc.setFillColor(230, 231, 232);
      doc.rect(15, 32, 186, 10, "F");
      doc.text(pageW / 2, 38, "DATOS DEL VEHÍCULO", { align: "center" });
      doc.addImage(vehiculoIcon, "png", 95, 46, 25, 25, undefined, "FAST");
      // PLACA
      doc.text(left, 76, "PLACA:");
      doc.setFont("helvetica", "normal");
      doc.text(30, 76, (inspeccion?.vehiculo?.placa ?? "").toString());
      // MARCA
      doc.setFont("helvetica", "bold");
      doc.text(left, 82, "MARCA:");
      doc.setFont("helvetica", "normal");
      doc.text(30, 82, (inspeccion?.vehiculo?.marca ?? "").toString());
      // MODELO
      doc.setFont("helvetica", "bold");
      doc.text(left, 88, "MODELO:");
      doc.setFont("helvetica", "normal");
      doc.text(33, 88, (inspeccion?.vehiculo?.modelo ?? "").toString());
      // CLASE
      doc.setFont("helvetica", "bold");
      doc.text(left, 94, "CLASE:");
      doc.setFont("helvetica", "normal");
      doc.text(30, 94, (inspeccion?.vehiculo?.clase ?? "").toString());
      // COLOR
      doc.setFont("helvetica", "bold");
      doc.text(left, 100, "COLOR:");
      doc.setFont("helvetica", "normal");
      doc.text(30, 100, (inspeccion?.vehiculo?.color ?? "").toString());
      // CILINDRAJE
      doc.setFont("helvetica", "bold");
      doc.text(left, 106, "CILINDRAJE:");
      doc.setFont("helvetica", "normal");
      doc.text(
        38,
        106,
        (inspeccion?.vehiculo?.cilindraje ?? "").toString(),
      );
      // RODAMIENTO
      doc.setFont("helvetica", "bold");
      doc.text(left, 112, "RODAMIENTO:");
      doc.setFont("helvetica", "normal");
      doc.text(
        41,
        112,
        (inspeccion?.vehiculo?.conRodamiento ?? "")
          .toString()
          .toUpperCase(),
      );
      // DISPOSITIVO / CLIENTE
      doc.setFont("helvetica", "bold");
      doc.text(left, 118, "DISPOSITIVO/CLIENTE:");
      doc.setFont("helvetica", "normal");
      doc.text(
        56,
        118,
        (inspeccion?.vehiculo?.dispositivoZonaCliente ?? "").toString(),
      );
      // IMÁGENES DEL VEHÍCULO
      let y = 124;
      y = await renderVehiculoImagenes(y);
      // KILOMETRAJE
      y = asegurarEspacio(
        inspeccion?.vehiculo?.imagenes?.length > 0 ? y + 6 : y,
        16,
      );
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      // La cargada desde papel sin kilometraje se guarda en 0, que no es una lectura: no se imprime
      const sinKilometrajeEnPapel =
        !!inspeccion?.cargadaDesdePapel &&
        !(Number(inspeccion?.vehiculo?.kilometraje) > 0);
      if (!sinKilometrajeEnPapel) {
        doc.text(left, y, "KILOMETRAJE");
        y += 6;
        doc.setFont("helvetica", "bold");
        doc.text(left, y, "INSPECCIÓN:");
        doc.setFont("helvetica", "normal");
        doc.text(40, y, (inspeccion?.vehiculo?.kilometraje ?? "").toString());
        y += 10;
      }
      // SOAT
      y = asegurarEspacio(y, 26);
      doc.setFont("helvetica", "bold");
      doc.text(left, y, "VENCIMIENTO DE SOAT");
      y += 6;
      imprimirKV(
        y,
        "ENTIDAD:",
        inspeccion?.vehiculo?.documentos?.soat?.entidad,
        33,
      );
      y += 6;
      imprimirKV(
        y,
        "VENCIMIENTO:",
        inspeccion?.vehiculo?.documentos?.soat?.vencimiento,
        42,
      );
      y += 6;
      imprimirKV(
        y,
        "ESTADO:",
        inspeccion?.vehiculo?.documentos?.soat?.estado,
        32,
      );
      y += 10;
      // TECNOMECÁNICA
      y = asegurarEspacio(y, 26);
      doc.setFont("helvetica", "bold");
      doc.text(left, y, "VENCIMIENTO DE TECNOMECÁNICA");
      y += 6;
      imprimirKV(
        y,
        "ENTIDAD:",
        inspeccion?.vehiculo?.documentos?.tecno?.entidad,
        33,
      );
      y += 6;
      imprimirKV(
        y,
        "VENCIMIENTO:",
        inspeccion?.vehiculo?.documentos?.tecno?.vencimiento,
        42,
      );
      y += 6;
      imprimirKV(
        y,
        "ESTADO:",
        inspeccion?.vehiculo?.documentos?.tecno?.estado,
        32,
      );
      y += 10;
      // CARTA DE PROPIEDAD
      if (inspeccion?.tipo === "Trimestral") {
        y = asegurarEspacio(y, 26);
        doc.setFont("helvetica", "bold");
        doc.text(left, y, "CARTA DE PROPIEDAD");
        y += 6;
        imprimirKV(
          y,
          "ENTIDAD:",
          inspeccion?.vehiculo?.documentos?.cartaPropiedad?.entidad,
          33,
        );
        y += 6;
        imprimirKV(
          y,
          "NÚMERO:",
          inspeccion?.vehiculo?.documentos?.cartaPropiedad?.numero,
          33,
        );
        y += 6;
        imprimirKV(
          y,
          "EXPEDICIÓN:",
          inspeccion?.vehiculo?.documentos?.cartaPropiedad?.expedicion,
          39,
        );
        y += 10;
      }
      // REVISIÓN DE COMPARENDOS
      if (inspeccion.esRodamiento === "Si") {
        y = asegurarEspacio(y, 12);
        doc.setFont("helvetica", "bold");
        doc.text(left, y, "REVISIÓN DE COMPARENDOS");
        y += 10;
        const comparendos =
          inspeccion.vehiculo.documentos.comparendos || [];
        if (comparendos.length > 0) {
          const lineHeight = 6;
          const bottomMargin = 20;
          const siguientePagina = () => {
            y = agregarPaginaConCabecera();
          };
          const asegurarLinea = () => {
            if (y + lineHeight > pageH - bottomMargin) {
              siguientePagina();
            }
          };
          comparendos.forEach((item, index) => {
            const detalleClean = (item.detalle || "")
              .replace(/\s*\n\s*/g, " ")
              .replace(/\s+/g, " ")
              .trim();
            const lines = doc.splitTextToSize(detalleClean, 170);
            const neededHeight = (lines.length + 3) * lineHeight + 4;
            const maxUsableOnFreshPage = pageH - bottomMargin - 35;
            const canKeepTogether = neededHeight <= maxUsableOnFreshPage;
            if (
              index > 0 &&
              canKeepTogether &&
              y + neededHeight > pageH - bottomMargin
            ) {
              siguientePagina();
            }
            // FECHA
            asegurarLinea();
            doc.setFont("helvetica", "bold");
            doc.text(left, y, "FECHA DE IMPOSICIÓN:");
            doc.setFont("helvetica", "normal");
            doc.text(58, y, item.fechaImposicion || "");
            y += lineHeight;
            // IMPUESTO EN
            asegurarLinea();
            doc.setFont("helvetica", "bold");
            doc.text(left, y, "IMPUESTO EN:");
            doc.setFont("helvetica", "normal");
            doc.text(42, y, item.ciudad || "");
            y += lineHeight;
            // CAUSAL
            asegurarLinea();
            doc.setFont("helvetica", "bold");
            doc.text(left, y, `CAUSAL ${item.causal}:`);
            const causalWidth = doc.getTextWidth(`CAUSAL ${item.causal}:`);
            doc.setFont("helvetica", "normal");
            doc.text(left + causalWidth + 2, y, lines[0] || "");
            y += lineHeight;
            // DETALLE
            for (let i = 1; i < lines.length; i++) {
              asegurarLinea();
              doc.text(left, y, lines[i]);
              y += lineHeight;
            }
            // ESTADO
            asegurarLinea();
            doc.setFont("helvetica", "bold");
            doc.text(left, y, "ESTADO:");
            doc.setFont("helvetica", "normal");
            doc.setTextColor(190, 64, 64);
            doc.text(32, y, item.estado || "");
            doc.setTextColor(0, 0, 0);
            y += lineHeight + 4;
          });
        } else {
          y = asegurarEspacio(y - 4, 8);
          doc.setFont("helvetica", "normal");
          doc.text(
            left,
            y,
            "No hay revisiones de comparendos registradas para el vehículo inspeccionado.",
          );
          y += 10;
        }
      }

      /* DATOS DEL CONDUCTOR */
      agregarPaginaConCabecera();
      // TITULO
      doc.setTextColor(0, 0, 0);
      const conductor = new Image();
      conductor.src = require("@/assets/img/icono_perfil.png");
      doc.setFillColor(230, 231, 232);
      doc.rect(15, 32, 186, 10, "F");
      doc.text(width / 2, 38, "DATOS DEL CONDUCTOR", { align: "center" });
      doc.addImage(conductor, "png", 95, 46, 23, 23, undefined, "FAST");
      // NOMBRE
      doc.text(15, 76, "NOMBRE:");
      doc.setFont("helvetica", "normal");
      doc.text(33, 76, (inspeccion?.conductor?.nombre ?? "").toString());
      doc.setFont("helvetica", "bold");
      // NÚMERO DE IDENTIFICACIÓN
      doc.text(15, 82, "NÚMERO DE IDENTIFICACIÓN:");
      doc.setFont("helvetica", "normal");
      doc.text(
        68,
        82,
        (inspeccion?.conductor?.numeroIdentificacion ?? "").toString(),
      );
      doc.setFont("helvetica", "bold");
      // CORREO
      doc.text(15, 88, "CORREO:");
      doc.setFont("helvetica", "normal");
      doc.text(33, 88, (inspeccion?.conductor?.correo ?? "").toString());
      doc.setFont("helvetica", "bold");
      // CARGO
      doc.text(15, 94, "CARGO:");
      doc.setFont("helvetica", "normal");
      doc.text(30, 94, (inspeccion?.conductor?.cargo ?? "").toString());
      doc.setFont("helvetica", "bold");
      // RODAMIENTO
      doc.text(15, 100, "RODAMIENTO:");
      doc.setFont("helvetica", "normal");
      doc.text(
        41,
        100,
        (inspeccion?.conductor?.conRodamiento ?? "")
          .toString()
          .toUpperCase(),
      );
      doc.setFont("helvetica", "bold");
      // DISPOSITIVO/CLIENTE
      doc.text(15, 106, "DISPOSITIVO/CLIENTE:");
      doc.setFont("helvetica", "normal");
      doc.text(
        56,
        106,
        (inspeccion?.conductor?.dispositivoZonaCliente ?? "").toString(),
      );
      // EXPEDICIÓN DE LICENCIA DE CONDUCCIÓN
      doc.setFont("helvetica", "bold");
      doc.text(15, 117, "EXPEDICIÓN DE LICENCIA DE CONDUCCIÓN");
      doc.text(15, 123, "ID:");
      doc.setFont("helvetica", "normal");
      doc.text(
        20,
        123,
        (
          inspeccion?.conductor?.documentos?.licencia?.identificacion ?? ""
        ).toString(),
      );
      doc.setFont("helvetica", "bold");
      doc.text(15, 129, "EXPEDICIÓN:");
      doc.setFont("helvetica", "normal");
      doc.text(
        39,
        129,
        (
          inspeccion?.conductor?.documentos?.licencia?.expedicion ?? ""
        ).toString(),
      );
      doc.setFont("helvetica", "bold");
      doc.text(15, 135, "CATEGORÍAS:");
      doc.setFont("helvetica", "normal");
      doc.text(
        41,
        135,
        (
          inspeccion?.conductor?.documentos?.licencia?.categorias ?? ""
        ).toString(),
      );
      // EXAMEN PSICOSENSOMÉTRICO
      if (inspeccion?.esRodamiento === "Si") {
        doc.setFont("helvetica", "bold");
        doc.text(15, 146, "EXAMEN PSICOSENSOMÉTRICO");
        doc.text(15, 152, "IPS:");
        doc.setFont("helvetica", "normal");
        doc.text(
          23,
          152,
          (inspeccion?.conductor?.documentos?.examen?.ips ?? "").toString(),
        );
        doc.setFont("helvetica", "bold");
        doc.text(15, 158, "VENCIMIENTO:");
        doc.setFont("helvetica", "normal");
        doc.text(
          42,
          158,
          (
            inspeccion?.conductor?.documentos?.examen?.vencimiento ?? ""
          ).toString(),
        );
        doc.setFont("helvetica", "bold");
        doc.text(15, 164, "ESTADO:");
        doc.setFont("helvetica", "normal");
        doc.text(
          32,
          164,
          (
            inspeccion?.conductor?.documentos?.examen?.estado ?? ""
          ).toString(),
        );
      }
      // CAPACITACIÓN / CURSO VIAL
      doc.setFont("helvetica", "bold");
      doc.text(
        15,
        inspeccion?.esRodamiento === "Si" ? 175 : 146,
        "CAPACITACIÓN / CURSO VIAL",
      );
      doc.text(
        15,
        inspeccion?.esRodamiento === "Si" ? 181 : 152,
        "NOMBRE:",
      );
      doc.setFont("helvetica", "normal");
      doc.text(
        34,
        inspeccion?.esRodamiento === "Si" ? 181 : 152,
        (
          inspeccion?.conductor?.documentos?.capacitacion?.nombre ?? ""
        ).toString(),
      );
      doc.setFont("helvetica", "bold");
      doc.text(
        15,
        inspeccion?.esRodamiento === "Si" ? 187 : 158,
        "VENCIMIENTO:",
      );
      doc.setFont("helvetica", "normal");
      doc.text(
        42,
        inspeccion?.esRodamiento === "Si" ? 187 : 158,
        (
          inspeccion?.conductor?.documentos?.capacitacion?.vencimiento ?? ""
        ).toString(),
      );
      doc.setFont("helvetica", "bold");
      doc.text(
        15,
        inspeccion?.esRodamiento === "Si" ? 193 : 164,
        "ESTADO:",
      );
      doc.setFont("helvetica", "normal");
      doc.text(
        32,
        inspeccion?.esRodamiento === "Si" ? 193 : 164,
        (
          inspeccion?.conductor?.documentos?.capacitacion?.estado ?? ""
        ).toString(),
      );
      // REVISIÓN DE COMPARENDOS
      if (inspeccion.esRodamiento === "Si") {
        doc.setFont("helvetica", "bold");
        doc.text(15, 204, "REVISIÓN DE COMPARENDOS");

        const comparendos =
          inspeccion?.conductor?.documentos?.comparendos || [];
        if (comparendos.length > 0) {
          const pageHeight = doc.internal.pageSize.getHeight();
          let currentY = 214;
          const lineHeight = 6;
          const bottomMargin = 20;

          const nextPage = () => {
            currentY = agregarPaginaConCabecera(); // ✅ nueva página con header
          };

          const asegurarLinea = () => {
            if (currentY + lineHeight > pageHeight - bottomMargin) {
              nextPage();
            }
          };

          comparendos.forEach((item, index) => {
            // ✅ Limpia saltos de línea del backend/BD para evitar conteos inflados
            const detalleClean = (item.detalle || "")
              .replace(/\s*\n\s*/g, " ")
              .replace(/\s+/g, " ")
              .trim();

            const lines = doc.splitTextToSize(detalleClean, 170);

            // altura estimada del comparendo completo
            const neededHeight = (lines.length + 3) * lineHeight + 4;

            // si cabe en una página “normal”, intentamos mantenerlo junto
            const maxUsableOnFreshPage = pageHeight - bottomMargin - 35; // margen + header/título
            const canKeepTogether = neededHeight <= maxUsableOnFreshPage;

            if (
              index > 0 &&
              canKeepTogether &&
              currentY + neededHeight > pageHeight - bottomMargin
            ) {
              nextPage();
            }

            // FECHA
            asegurarLinea();
            doc.setFont("helvetica", "bold");
            doc.text(15, currentY, "FECHA DE IMPOSICIÓN:");
            doc.setFont("helvetica", "normal");
            doc.text(58, currentY, (item.fechaImposicion ?? "").toString());
            currentY += lineHeight;

            // IMPUESTO EN
            asegurarLinea();
            doc.setFont("helvetica", "bold");
            doc.text(15, currentY, "IMPUESTO EN:");
            doc.setFont("helvetica", "normal");
            doc.text(42, currentY, (item.ciudad ?? "").toString());
            currentY += lineHeight;

            // CAUSAL + primera línea del detalle
            asegurarLinea();
            doc.setFont("helvetica", "bold");
            doc.text(
              15,
              currentY,
              `CAUSAL ${(item.causal ?? "").toString()}:`,
            );
            const causalWidth = doc.getTextWidth(
              `CAUSAL ${(item.causal ?? "").toString()}:`,
            );
            doc.setFont("helvetica", "normal");
            doc.text(
              15 + causalWidth + 2,
              currentY,
              (lines[0] ?? "").toString(),
            );
            currentY += lineHeight;

            // resto del detalle (partible entre páginas sin huecos)
            for (let i = 1; i < lines.length; i++) {
              asegurarLinea();
              doc.text(15, currentY, (lines[i] ?? "").toString());
              currentY += lineHeight;
            }

            // ESTADO
            asegurarLinea();
            doc.setFont("helvetica", "bold");
            doc.text(15, currentY, "ESTADO:");
            doc.setFont("helvetica", "normal");
            doc.setTextColor(190, 64, 64);
            doc.text(32, currentY, (item.estado ?? "").toString());
            doc.setTextColor(0, 0, 0);

            currentY += lineHeight + 4;
          });
        } else {
          doc.setTextColor(0, 0, 0);
          doc.setFont("helvetica", "normal");
          doc.text(
            15,
            210,
            "No hay revisiones de comparendos registradas para este conductor.",
          );
        }
      }

      /* DATOS DEL SUPERVISOR / COORDINADOR */
      agregarPaginaConCabecera();
      // TITULO
      doc.setTextColor(0, 0, 0);
      const supervisor = new Image();
      supervisor.src = require("@/assets/img/icono_perfil.png");
      doc.setFont("helvetica", "bold");
      doc.setFillColor(230, 231, 232);
      doc.rect(15, 32, 186, 10, "F");
      doc.text(width / 2, 38, "DATOS DEL SUPERVISOR / COORDINADOR", {
        align: "center",
      });
      doc.addImage(supervisor, "png", 95, 46, 23, 23, undefined, "FAST");
      // NOMBRE
      doc.text(15, 76, "NOMBRE:");
      doc.setFont("helvetica", "normal");
      doc.text(33, 76, (inspeccion?.supervisor?.nombre ?? "").toString());
      doc.setFont("helvetica", "bold");
      // NÚMERO DE IDENTIFICACIÓN
      doc.text(15, 82, "NÚMERO DE IDENTIFICACIÓN:");
      doc.setFont("helvetica", "normal");
      doc.text(
        68,
        82,
        (inspeccion?.supervisor?.numeroIdentificacion ?? "").toString(),
      );
      doc.setFont("helvetica", "bold");
      // CORREO
      doc.text(15, 88, "CORREO:");
      doc.setFont("helvetica", "normal");
      doc.text(33, 88, (inspeccion?.supervisor?.correo ?? "").toString());
      doc.setFont("helvetica", "bold");
      // CARGO
      doc.text(15, 94, "CARGO:");
      doc.setFont("helvetica", "normal");
      doc.text(30, 94, (inspeccion?.supervisor?.cargo ?? "").toString());

      /* DATOS DE LA UBICACIÓN */
      // TITULO
      const ubicacion = new Image();
      ubicacion.src = require("@/assets/img/icono_ubicacion.png");
      doc.setFillColor(230, 231, 232);
      doc.rect(15, 110, 186, 10, "F");
      doc.setFont("helvetica", "bold");
      doc.text(width / 2, 116, "DATOS DEL PUESTO DE TRABAJO", {
        align: "center",
      });
      doc.addImage(ubicacion, "png", 95, 122, 23, 23, undefined, "FAST");
      // EMPRESA
      doc.text(15, 152, "EMPRESA:");
      doc.setFont("helvetica", "normal");
      doc.text(35, 152, (inspeccion?.ubicacion?.empresa ?? "").toString());
      doc.setFont("helvetica", "bold");
      // PAÍS
      doc.text(15, 158, "PAÍS:");
      doc.setFont("helvetica", "normal");
      doc.text(
        26,
        158,
        (inspeccion?.ubicacion?.pais ?? "").toString().toUpperCase(),
      );
      doc.setFont("helvetica", "bold");
      // DEPARTAMENTO
      doc.text(15, 164, "DEPARTAMENTO:");
      doc.setFont("helvetica", "normal");
      doc.text(
        47,
        164,
        (inspeccion?.ubicacion?.departamento ?? "")
          .toString()
          .toUpperCase(),
      );
      doc.setFont("helvetica", "bold");
      // CIUDAD
      doc.text(15, 170, "CIUDAD:");
      doc.setFont("helvetica", "normal");
      doc.text(
        32,
        170,
        (inspeccion?.ubicacion?.ciudad ?? "").toString().toUpperCase(),
      );

      /* DATOS DE LA INSPECCIÓN */
      // TITULO
      doc.setFillColor(230, 231, 232);
      doc.rect(15, 186, 186, 10, "F");
      doc.setFont("helvetica", "bold");
      doc.text(width / 2, 192, "DATOS DE LA INSPECCIÓN", {
        align: "center",
      });
      // RESULTADO DE LA INSPECCIÓN
      doc.text(15, 206, "RESULTADO DE LA INSPECCIÓN:");
      doc.setFont("helvetica", "bold");
      if (inspeccion?.resultado == "Apto") {
        doc.setTextColor(32, 132, 84);
        doc.text(
          74,
          206,
          (inspeccion?.resultado ?? "").toString().toUpperCase(),
        );
      }
      if (inspeccion?.resultado == "Con Control Específico") {
        doc.setTextColor(218, 160, 59);
        doc.text(
          74,
          206,
          (inspeccion?.resultado ?? "").toString().toUpperCase(),
        );
      }
      if (inspeccion?.resultado == "No Apto") {
        doc.setTextColor(190, 64, 64);
        doc.text(
          74,
          206,
          (inspeccion?.resultado ?? "").toString().toUpperCase(),
        );
      }
      // FECHA DE INSPECCIÓN
      doc.setTextColor(0, 0, 0);
      doc.text(15, 212, "FECHA DE INSPECCIÓN:");
      doc.setFont("helvetica", "normal");
      doc.text(58, 212, (inspeccion?.registro ?? "").toString());
      // TIPO DE INSPECCIÓN
      doc.setFont("helvetica", "bold");
      doc.text(15, 218, "TIPO DE INSPECCIÓN:");
      doc.setFont("helvetica", "normal");
      doc.text(54, 218, (inspeccion?.tipo ?? "").toString().toUpperCase());
      // RODAMIENTO DE INSPECCIÓN
      doc.setFont("helvetica", "bold");
      doc.text(15, 224, "RODAMIENTO DE INSPECCIÓN:");
      doc.setFont("helvetica", "normal");
      doc.text(
        70,
        224,
        (inspeccion?.esRodamiento ?? "").toString().toUpperCase(),
      );
      // ORIGEN: SOLO LAS CARGADAS DESDE PAPEL
      if (inspeccion?.cargadaDesdePapel) {
        doc.setFont("helvetica", "bold");
        doc.text(15, 230, "ORIGEN:");
        const anchoOrigen = doc.getTextWidth("ORIGEN: ");
        doc.setFont("helvetica", "normal");
        doc.text(
          15 + anchoOrigen,
          230,
          `CARGADA DESDE PAPEL EL ${inspeccion.cargadaDesdePapel}`,
        );
      }

      /* MAPA DE UBICACIÓN */
      if (mapa) {
        agregarPaginaConCabecera();
        doc.setFont("helvetica", "bold");
        doc.text(width / 2, 38, "MAPA DE UBICACIÓN DE LA INSPECCIÓN", {
          align: "center",
        });
        try {
          const imgWidth = 180;
          const imgHeight = 120;
          const xPos = (width - imgWidth) / 2;
          if (mapa) {
            doc.addImage(
              mapa,
              "png",
              xPos,
              45,
              imgWidth,
              imgHeight,
              undefined,
              "FAST",
            );
            const maxWidth = doc.internal.pageSize.getWidth() - 15 - 15;
            const direccionMapa = (direccion || "").trim();
            const label = `DIRECCIÓN: `;
            const labelW = doc.getTextWidth(label);
            const textoDireccion = direccionMapa
              ? `${direccionMapa}`
              : "No hay una dirección para las coordenadas registradas en la inspección.";
            const lines = doc.splitTextToSize(textoDireccion, maxWidth);
            doc.setFont("helvetica", "bold");
            doc.text(15, 45 + imgHeight + 10, label);
            doc.setFont("helvetica", "normal");
            doc.text(15 + labelW, 45 + imgHeight + 10, lines);
          }
        } catch (error) {
          doc.setFont("helvetica", "normal");
          doc.text(width / 2, 100, "No se pudo cargar la imagen del mapa", {
            align: "center",
          });
        }
      }

      /* FORMATOS */
      let items = inspeccion.items.map((item) => {
        return {
          nombre: item.nombre,
          campos: item.campos.map((campo) => {
            return {
              id: item.nombre,
              ...campo,
            };
          }),
        };
      });
      for (let i = 0; i < items.length; i++) {
        let info = [];
        const element = items[i];
        let nombreFormato = element.nombre;
        for (const item of element.campos) {
          if (nombreFormato == item.id) {
            info.push([
              item.nombre,
              item.respuesta,
              item.observacion,
              item.criterio,
            ]);
          }
        }
        agregarPaginaConCabecera();
        doc.setFont("helvetica", "bold");
        doc.text(width / 2, 28, nombreFormato.toUpperCase(), {
          align: "center",
        });
        doc.autoTable({
          headStyles: {
            fontSize: 12,
            fillColor: [7, 61, 122],
            textColor: [255, 255, 255],
            halign: "middle",
          },
          bodyStyles: {
            textColor: [0, 0, 0],
            fontStyle: "normal",
            fontSize: 10,
          },
          tableLineColor: [0, 0, 0],
          tableLineWidth: 0.1,
          styles: {
            lineColor: [0, 0, 0],
            lineWidth: 0.1,
          },
          theme: "grid",
          startY: 40,
          margin: { left: 15 },
          head: [["ITEM", "VALOR", "OBSERVACIÓN"]],
          body: info,
          didParseCell: (data) => {
            if (data.section === "body" && data.column.index === 0) {
              const criterio = data.row.raw[3];
              data.row.cells[0].styles.fillColor =
                criterio === "Con Control Específico"
                  ? "#FFE2C5"
                  : criterio === "No Apto"
                    ? "#FFDDDD"
                    : null;
              data.row.cells[1].styles.fillColor =
                criterio === "Con Control Específico"
                  ? "#FFE2C5"
                  : criterio === "No Apto"
                    ? "#FFDDDD"
                    : null;
              data.row.cells[2].styles.fillColor =
                criterio === "Con Control Específico"
                  ? "#FFE2C5"
                  : criterio === "No Apto"
                    ? "#FFDDDD"
                    : null;
            }
          },
        });
      }

      /* USUARIO QUE REALIZÓ LA INSPECCIÓN */
      agregarPaginaConCabecera();
      // TITULO
      const encargado = new Image();
      encargado.src = require("@/assets/img/icono_perfil.png");
      doc.setFont("helvetica", "bold");
      doc.setFillColor(230, 231, 232);
      doc.rect(15, 32, 186, 10, "F");
      doc.text(width / 2, 38, "ENCARGADO DE LA INSPECCIÓN", {
        align: "center",
      });
      doc.addImage(encargado, "png", 95, 46, 23, 23, undefined, "FAST");
      // NOMBRE
      doc.text(15, 76, "NOMBRE:");
      doc.setFont("helvetica", "normal");
      doc.text(33, 76, (inspeccion?.encargado?.nombre ?? "").toString());
      doc.setFont("helvetica", "bold");
      // NÚMERO DE IDENTIFICACIÓN
      doc.text(15, 81, "NÚMERO DE IDENTIFICACIÓN:");
      doc.setFont("helvetica", "normal");
      doc.text(
        68,
        81,
        (inspeccion?.encargado?.numeroIdentificacion ?? "").toString(),
      );
      doc.setFont("helvetica", "bold");
      // CORREO
      doc.text(15, 86, "CORREO:");
      doc.setFont("helvetica", "normal");
      doc.text(33, 86, (inspeccion?.encargado?.correo ?? "").toString());
      doc.setFont("helvetica", "bold");
      // CARGO
      doc.text(15, 91, "CARGO:");
      doc.setFont("helvetica", "normal");
      doc.text(30, 91, (inspeccion?.encargado?.cargo ?? "").toString());

      /* DECLARACIÓN DE VERACIDAD */
      // VARIABLES
      const boxX = 15;
      const boxY = 121;
      const boxSize = 4;
      const pageWidth = doc.internal.pageSize.getWidth();
      const rightMargin = 15;
      const gap = 2;
      const textX = boxX + boxSize + gap;
      const textY = 124;
      const texto = `Acepto que todo lo consignado en este documento es veraz y que puede ser verificado por la compañía, de encontrarse alguna novedad en lo reportado, asumo las consecuencias que esto implica frente al cumplimiento de las normas y/o procedimientos emitidos por la empresa.`;
      const maxWidth = pageWidth - rightMargin - textX;
      const lineas = doc.splitTextToSize(texto, maxWidth);
      // TITULO
      doc.setFont("helvetica", "bold");
      doc.setFillColor(230, 231, 232);
      doc.rect(15, 107, 186, 10, "F");
      doc.text(width / 2, 113, "DECLARACIÓN DE VERACIDAD", {
        align: "center",
      });
      doc.setFont("helvetica", "normal");
      dibujarCheckbox(
        doc,
        boxX,
        boxY,
        boxSize,
        inspeccion?.declaracionVeracidad === "Si" ? true : false,
      );
      doc.text(lineas, textX, textY);

      /* PIE DE PÁGINA */
      let pageCount = doc.internal.getNumberOfPages();
      for (let i = 0; i < pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(10);
        doc.text(
          15,
          doc.internal.pageSize.height - 5,
          `Descargado por: ${(usuario?.nombre ?? "").toString()} - ${(
            usuario?.correo ?? ""
          ).toString()}`,
        );
      }
      if (descargar) {
        doc.save(
          `Inspección de Vehículo ${inspeccion.vehiculo.placa} (${inspeccion.registro}).pdf`,
        );
      } else {
        return doc.output("blob");
      }
    },
    async descargarZIP(rows, state) {
      const Swal = require("sweetalert2");
      const JSZip = require("jszip");
      const zip = new JSZip();
      const batchSize = 5;
      const total = rows.length;
      let procesados = 0;

      Swal.fire({
        title:
          '<span style="font-size: 18px; font-weight: 600; color: #073d7a;">Preparando descarga masiva</span>',
        html: `<div style="font-size: 14px; color: #555; margin-top: 8px;">Procesando reportes: <b>0</b> de <b>${total}</b>...</div>`,
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      for (let i = 0; i < total; i += batchSize) {
        const batch = rows.slice(i, i + batchSize);

        await Promise.all(
          batch.map(async (item) => {
            try {
              const info = await state.obtenerInformacionInspeccion(item);
              if (info && info.inspeccion && info.usuario) {
                const pdfBlob =
                  await state.inspeccion.funciones.generarInforme(
                    info.inspeccion,
                    info.usuario,
                    false,
                  );
                const cleanPlaca = (
                  info.inspeccion.vehiculo.placa || ""
                ).replace(/[^a-zA-Z0-9]/g, "");
                const cleanRegistro = (
                  info.inspeccion.registro || ""
                  // eslint-disable-next-line no-useless-escape -- escapes de más en la regex; no cambian lo que encuentra
                ).replace(/[\/\:\s]/g, "_");
                const nombreArchivo = `Inspeccion_${cleanPlaca}_${cleanRegistro}.pdf`;
                zip.file(nombreArchivo, pdfBlob);
              }
            } catch (error) {
              console.error(
                "Error al procesar reporte individual en ZIP:",
                error,
              );
            } finally {
              procesados++;
              const bElem = Swal.getHtmlContainer()?.querySelector("b");
              if (bElem) {
                bElem.textContent = procesados;
              }
            }
          }),
        );
      }

      const zipBlob = await zip.generateAsync({ type: "blob" });
      Swal.close();

      const moment = require("moment");
      const timestamp = moment().format("DD_MM_YYYY_HH_mm_ss_A");
      const downloadLink = document.createElement("a");
      downloadLink.href = URL.createObjectURL(zipBlob);
      downloadLink.download = `Inspecciones_Generadas_${timestamp}.zip`;
      downloadLink.click();
      URL.revokeObjectURL(downloadLink.href);
    },
    descargarExcelCompleto(rows, nombre) {
      /* INICIALIZAR LIBRERIA */
      const XLSX = require("sheetjs-style");

      /* CREAR LIBRO */
      const wb = XLSX.utils.book_new();

      /* SEPARAR LOS REGISTROS CON Y SIN "CAMPOS.FORMATO.NOMBRE" */
      const registrosConFormato = rows.filter(
        (row) => row.campos?.formato?.nombre,
      );
      const registrosSinFormato = rows.filter(
        (row) => !row.campos?.formato?.nombre,
      );

      /* ESTILOS GENERALES DE CABERCERAS */
      const mergeHeaderStyle = {
        font: {
          bold: true,
          sz: 12,
          name: "Calibri",
          color: { rgb: "F3F3F3" },
        },
        alignment: {
          wrapText: true,
          horizontal: "center",
          vertical: "center",
        },
        fill: { fgColor: { rgb: "073d7a" } },
        border: {
          top: { style: "thin", color: { rgb: "FFFFFF" } },
          bottom: { style: "thin", color: { rgb: "FFFFFF" } },
          left: { style: "thin", color: { rgb: "FFFFFF" } },
          right: { style: "thin", color: { rgb: "FFFFFF" } },
        },
      };

      /* ESTILOS GENERALES DE CELDAS */
      const dataCellStyle = {
        border: {
          top: { style: "thin", color: 1 },
          bottom: { style: "thin", color: 1 },
          left: { style: "thin", color: 1 },
          right: { style: "thin", color: 1 },
        },
        font: {
          name: "Arial",
          sz: 10,
          bold: false,
        },
        alignment: {
          wrapText: true,
          horizontal: "center",
          vertical: "center",
        },
      };

      /* AGRUPAR REGISTROS CON FORMATO */
      const groupedData = _.groupBy(
        registrosConFormato,
        "campos.formato.nombre",
      );

      /* GENERAR HOJAS DE REGISTROS CON FORMATO */
      Object.entries(groupedData).forEach(([groupName, groupRows]) => {
        /* DEFINIR NOMBRE A LA HOJA */
        const sheetName =
          groupName.length > 31 ? groupName.slice(0, 31) : groupName;

        /* GENERAR CABECERAS DINÁMICAS */
        const dynamicHeaders = [
          ...new Set(
            groupRows.flatMap(
              (item) =>
                item.campos?.items?.map((campo) => campo.nombre) || [],
            ),
          ),
        ];

        /* DEFINICIÓN DE ENCABEZADOS */

        /* CALCULAR LA CANTIDAD DE COLUMNAS EN EL GRUPO */
        const groupFormatoCount = 7 + 2 * dynamicHeaders.length;

        /* NIVEL 1 - ENCABEZADOS DE GRUPO */
        const headerRow1 = [
          "FECHA",
          "REGISTRO",
          "DECLARACIÓN DE VERACIDAD",
          "RODAMIENTO DE INSPECCIÓN",
          "TIPO DE INSPECCIÓN",
          "RESULTADO DE INSPECCIÓN",
          "REALIZADA POR",
          "CONDUCTOR",
          "",
          "",
          "VEHÍCULO",
          "",
          "",
          "",
          "",
          "DOCUMENTOS DE VEHÍCULO",
          "",
          "",
          "DOCUMENTOS DE CONDUCTOR",
          "",
          "",
          "",
          "FORMATO DE INSPECCIÓN",
          ...Array(groupFormatoCount - 1).fill(""),
        ];

        /* NIVEL 2 - SUBENCABEZADOS EN GRUPO */
        const headerRow2 = [
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "NOMBRE",
          "RODAMIENTO",
          "DISPOSITIVO/CLIENTE",
          "PLACA",
          "CLASE",
          "IMÁGENES",
          "RODAMIENTO",
          "DISPOSITIVO/CLIENTE",
          "SOAT",
          "TÉCNICO MÉCANICA",
          "REVISIÓN DE COMPARENDOS",
          "LICENCIA DE CONDUCCIÓN",
          "EXAMEN",
          "CAPACITACIÓN",
          "REVISIÓN DE COMPARENDOS",
          "TOTAL SI",
          "TOTAL NO",
          "TOTAL BUENO",
          "TOTAL MALO",
          "TOTAL REGULAR",
          "TOTAL N/A",
          "TOTAL NO REGISTRA",
          ...dynamicHeaders.flatMap((header) => [header, ""]),
        ];

        /* NIVEL 3 - SOLO PARA EL GRUPO DINAMICO */
        const headerRow3 = [
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          ...Array(7).fill(""),
          ...dynamicHeaders.flatMap(() => ["VALOR", "OBSERVACIÓN"]),
        ];

        /* UNIR CABECERAS */
        const headers = [headerRow1, headerRow2, headerRow3];

        /* AÑADIR CABECERAS A LA HOJA */
        const ws = XLSX.utils.aoa_to_sheet(headers);

        /* CONFIGURAR UNIONES DE COLUMNAS */

        /* COLUMNAS SIMPLES (1, 2, 3, 4, 5, 6, 7) */
        const staticVerticalMerges = Array.from({ length: 7 }, (_, c) => ({
          s: { r: 0, c },
          e: { r: 2, c },
        }));

        /* UNIÓN DE CONDUCTOR (7, 8, 9) */
        const conductorHorizontal = {
          s: { r: 0, c: 7 },
          e: { r: 0, c: 9 },
        };
        const conductorVertical = [
          { s: { r: 1, c: 7 }, e: { r: 2, c: 7 } },
          { s: { r: 1, c: 8 }, e: { r: 2, c: 8 } },
          { s: { r: 1, c: 9 }, e: { r: 2, c: 9 } },
        ];

        /* UNIÓN DE VEHÍCULO (10, 11, 12, 13, 14) */
        const vehiculoHorizontal = {
          s: { r: 0, c: 10 },
          e: { r: 0, c: 14 },
        };
        const vehiculoVertical = [
          { s: { r: 1, c: 10 }, e: { r: 2, c: 10 } },
          { s: { r: 1, c: 11 }, e: { r: 2, c: 11 } },
          { s: { r: 1, c: 12 }, e: { r: 2, c: 12 } },
          { s: { r: 1, c: 13 }, e: { r: 2, c: 13 } },
          { s: { r: 1, c: 14 }, e: { r: 2, c: 14 } },
        ];

        /* DOCUMENTOS DEL VEHÍCULO (15, 16, 17) */
        const docsVehiculoHorizontal = {
          s: { r: 0, c: 15 },
          e: { r: 0, c: 17 },
        };
        const docsVehiculoVertical = Array.from({ length: 3 }, (_, i) => ({
          s: { r: 1, c: 15 + i },
          e: { r: 2, c: 15 + i },
        }));

        /* DOCUMENTOS DEL CONDUCTOR (18, 19, 20, 21) */
        const docsConductorHorizontal = {
          s: { r: 0, c: 18 },
          e: { r: 0, c: 21 },
        };
        const docsConductorVertical = Array.from({ length: 4 }, (_, i) => ({
          s: { r: 1, c: 18 + i },
          e: { r: 2, c: 18 + i },
        }));

        /* COLUMNA DE FORMATO DE INSPECCIÓN */
        const formatoMerge = {
          s: { r: 0, c: 22 },
          e: { r: 0, c: 22 + groupFormatoCount - 1 },
        };

        /* COLUMNAS DE LOS TOTALES */
        const totalesMerges = Array.from({ length: 7 }, (_, i) => ({
          s: { r: 1, c: 22 + i },
          e: { r: 2, c: 22 + i },
        }));

        /* COLUMNAS DINÁMICAS DEL FORMATO */
        const dynamicStart = 22 + 7;
        const dynamicMerges = dynamicHeaders.map((_, i) => ({
          s: { r: 1, c: dynamicStart + i * 2 },
          e: { r: 1, c: dynamicStart + i * 2 + 1 },
        }));

        /* UNIÓN DE TODAS LAS CABECERAS */
        ws["!merges"] = [
          ...staticVerticalMerges,
          conductorHorizontal,
          ...conductorVertical,
          vehiculoHorizontal,
          ...vehiculoVertical,
          docsVehiculoHorizontal,
          ...docsVehiculoVertical,
          docsConductorHorizontal,
          ...docsConductorVertical,
          formatoMerge,
          ...totalesMerges,
          ...dynamicMerges,
        ];

        /* CONFIGURACIÓN DE LOS DATOS */
        const jsonData = groupRows.map((item) => {
          const {
            vehiculo,
            conductor,
            fecha,
            registro,
            esRodamiento,
            tipo,
            resultado,
            realizadaPor,
          } = item;
          const vehDocs = vehiculo.documentos || {};
          const condDocs = conductor.documentos || {};

          const soat = vehDocs.idSoat ? "Si" : "No";
          const tecnicoMecanica = vehDocs.idTecnicoMecanica ? "Si" : "No";
          const revisionComparendosVehiculo = vehDocs.idRevision
            ? "Si"
            : "No";
          const licenciaConduccion = condDocs.idLicencia ? "Si" : "No";
          const examen = condDocs.idExamen ? "Si" : "No";
          const capacitacion = condDocs.idCapacitacion ? "Si" : "No";
          const revisionComparendosConductor = condDocs.idRevision
            ? "Si"
            : "No";

          /* ESTRUCTURAR LAS PROPIEDADES DE VALOR Y OBSERVACIÓN */
          const dynamicValues = {};
          item.campos?.items?.forEach((campo) => {
            dynamicValues[`${campo.nombre}_valor`] = campo.valor || "-";
            dynamicValues[`${campo.nombre}_observacion`] =
              campo.observacion || "-";
            dynamicValues[`${campo.nombre}_criterio`] =
              campo.criterio || "-";
          });

          return {
            fecha,
            registro,
            esRodamiento,
            tipoInspeccion: tipo,
            resultadoInspeccion: resultado,
            declaracionVeracidad: item.declaracionVeracidad,
            realizadaPor,
            conductor: conductor.nombre,
            rodamientoConductor: conductor.conRodamiento,
            dispositivoZonaClienteConductor:
              conductor.dispositivoZonaCliente
                ? conductor.dispositivoZonaCliente
                : "-",
            placa: item.placa,
            clase: vehiculo?.clase || "N/A",
            imagenesVehiculo:
              vehiculo.imagenes.length > 0
                ? vehiculo.imagenes.map((item) => item.url)
                : "-",
            rodamientoVehiculo: vehiculo.conRodamiento,
            dispositivoZonaClienteVehiculo: vehiculo.dispositivoZonaCliente
              ? vehiculo.dispositivoZonaCliente
              : "-",
            soat,
            tecnicoMecanica,
            revisionComparendosVehiculo,
            licenciaConduccion,
            examen,
            capacitacion,
            revisionComparendosConductor,
            totalSi: item.campos?.totales?.totalSi || 0,
            totalNo: item.campos?.totales?.totalNo || 0,
            totalBueno: item.campos?.totales?.totalBueno || 0,
            totalMalo: item.campos?.totales?.totalMalo || 0,
            totalRegular: item.campos?.totales?.totalRegular || 0,
            totalNA: item.campos?.totales?.totalNA || 0,
            totalNoRegistra: item.campos?.totales?.totalNoRegistra || 0,
            ...dynamicValues,
          };
        });

        /* DEFINIR CABECERAS PARA JSON */
        const jsonHeaders = [
          "fecha",
          "registro",
          "declaracionVeracidad",
          "esRodamiento",
          "tipoInspeccion",
          "resultadoInspeccion",
          "realizadaPor",
          "conductor",
          "rodamientoConductor",
          "dispositivoZonaClienteConductor",
          "placa",
          "clase",
          "imagenesVehiculo",
          "rodamientoVehiculo",
          "dispositivoZonaClienteVehiculo",
          "soat",
          "tecnicoMecanica",
          "revisionComparendosVehiculo",
          "licenciaConduccion",
          "examen",
          "capacitacion",
          "revisionComparendosConductor",
          "totalSi",
          "totalNo",
          "totalBueno",
          "totalMalo",
          "totalRegular",
          "totalNA",
          "totalNoRegistra",
          ...dynamicHeaders.flatMap((header) => [
            `${header}_valor`,
            `${header}_observacion`,
          ]),
        ];

        /* AÑADIR DATOS Y CABECERAS */
        const jsonDataClean = jsonData.map((row) => {
          const cleanRow = {};
          Object.keys(row).forEach((key) => {
            if (!key.endsWith("_criterio")) {
              cleanRow[key] = row[key];
            }
          });
          return cleanRow;
        });
        const imagenesColIndex = jsonHeaders.indexOf("imagenesVehiculo");
        const filasDatos = [];
        const mergesDatos = [];
        const linksToSet = [];
        let baseRow = 3;
        jsonDataClean.forEach((row, rowIdx) => {
          // NORMALIZAR ARREGLO DE IMÁGENES A 4 POSICIONES
          const imagenes = Array.isArray(row.imagenesVehiculo)
            ? row.imagenesVehiculo.slice(0, 4)
            : [];

          while (imagenes.length < 4) imagenes.push("");

          // CREAR 4 FILAS PARA ESTE REGISTRO
          imagenes.forEach((imgUrl, subIndex) => {
            const fila = jsonHeaders.map((header, colIndex) => {
              if (header === "imagenesVehiculo") {
                if (imgUrl) {
                  const etiqueta = `Imagen #${subIndex + 1}`;
                  linksToSet.push({
                    r: baseRow + subIndex,
                    c: colIndex,
                    url: imgUrl,
                    texto: etiqueta,
                  });
                  return etiqueta;
                }
                return "-";
              }
              return subIndex === 0 ? row[header] ?? "" : "";
            });
            filasDatos.push(fila);
          });

          // FUSIONAR TODAS LAS COLUMNAS DEL REGISTRO EXCEPTO IMÁGENES
          jsonHeaders.forEach((header, colIndex) => {
            if (colIndex === imagenesColIndex) return;
            mergesDatos.push({
              s: { r: baseRow, c: colIndex },
              e: { r: baseRow + 4 - 1, c: colIndex },
            });
          });
          baseRow += 4;
        });

        // ESCRIBIR DATOS
        XLSX.utils.sheet_add_aoa(ws, filasDatos, { origin: "A4" });

        // AÑADIR MERGES A DATOS EXISTENTES
        ws["!merges"] = [...ws["!merges"], ...mergesDatos];

        // APLICAR HIPERVÍNCULOS A CADA CELDA DE IMAGEN
        linksToSet.forEach(({ r, c, url, texto }) => {
          const cellRef = XLSX.utils.encode_cell({ r, c });
          if (!ws[cellRef]) {
            ws[cellRef] = { t: "s", v: texto };
          }
          ws[cellRef].l = { Target: url };
        });

        /* DEFINIR ANCHO DE LAS COLUMNAS */
        ws["!cols"] = [
          { wch: 15 }, // FECHA
          { wch: 20 }, // REGISTRO
          { wch: 30 }, // DECLARACIÓN DE VERACIDAD
          { wch: 30 }, // RODAMIENTO DE INSPECCIÓN
          { wch: 25 }, // TIPO DE INSPECCIÓN
          { wch: 30 }, // RESULTADO DE INSPECCIÓN
          { wch: 40 }, // REALIZADA POR
          { wch: 40 }, // CONDUCTOR - NOMBRE
          { wch: 25 }, // CONDUCTOR - RODAMIENTO
          { wch: 35 }, // CONDUCTOR - DISPOSITIVO/CLIENTE
          { wch: 25 }, // VEHICULO - PLACA
          { wch: 25 }, // VEHICULO - CLASE
          { wch: 25 }, // VEHICULO - IMÁGENES
          { wch: 25 }, // VEHICULO - RODAMIENTO
          { wch: 35 }, // VEHÍCULO - DISPOSITIVO/CLIENTE
          { wch: 30 }, // DOCUMENTOS VEHICULO - SOAT
          { wch: 25 }, // DOCUMENTOS VEHICULO - TECNICO MECANICA
          { wch: 35 }, // DOCUMENTOS VEHICULO - REVISIÓN DE COMPARENDOS
          { wch: 35 }, // DOCUMENTOS CONDUCTOR - LICENCIA DE CONDUCCIÓN
          { wch: 30 }, // DOCUMENTOS CONDUCTOR - EXAMEN
          { wch: 30 }, // DOCUMENTOS CONDUCTOR - CAPACITACIÓN
          { wch: 35 }, // DOCUMENTOS CONDUCTOR - REVISIÓN DE COMPARENDOS
          { wch: 20 }, // FORMATO DE INSPECCIÓN - TOTALES - TOTAL SI
          { wch: 20 }, // FORMATO DE INSPECCIÓN - TOTALES - TOTAL NO
          { wch: 20 }, // FORMATO DE INSPECCIÓN - TOTALES - TOTAL BUENO
          { wch: 20 }, // FORMATO DE INSPECCIÓN - TOTALES - TOTAL MALO
          { wch: 20 }, // FORMATO DE INSPECCIÓN - TOTALES - TOTAL REGULAR
          { wch: 20 }, // FORMATO DE INSPECCIÓN - TOTALES - TOTA N/A
          { wch: 20 }, // FORMATO DE INSPECCIÓN - TOTALES - TOTAL NO REGISTRA
          ...dynamicHeaders.flatMap(() => [{ wch: 30 }, { wch: 60 }]), // FORMATO DE INSPECCIÓN - CAMPOS DINÁMICOS
        ];

        /* ESTILOS DE CELDAS */

        /* ESTILOS BASE PARA SI Y NO */
        const yesStyle = {
          fill: { fgColor: { rgb: "208454" } },
          font: { bold: true, color: { rgb: "FFFFFFFF" } },
        };

        const noStyle = {
          fill: { fgColor: { rgb: "E6423C" } },
          font: { bold: true, color: { rgb: "FFFFFFFF" } },
        };

        /* ESTILOS PARA RESULTADOS DE INSPECCIÓN */
        const stylesByInspectionResult = {
          Apto: {
            fill: { fgColor: { rgb: "208454" } },
            font: { bold: true, color: { rgb: "FFFFFFFF" } },
          },
          "Con Control Específico": {
            fill: { fgColor: { rgb: "FFFFFF00" } },
            font: { bold: true },
          },
          "No Apto": {
            fill: { fgColor: { rgb: "E6423C" } },
            font: { bold: true, color: { rgb: "FFFFFFFF" } },
          },
        };

        /* FUNCION PARA DETERMINAR COLOR DE SI Y NO */
        function getStyleByValue(value, isComparendo = false) {
          if (isComparendo) {
            if (value === "-") {
              return value;
            } else {
              return value.toLowerCase() === "no" ? yesStyle : noStyle;
            }
          } else {
            if (value === "-") {
              return value;
            } else {
              return value.toLowerCase() === "si" ? yesStyle : noStyle;
            }
          }
        }

        /* ASIGNAR ESTILOS A CABECERAS */
        for (let R = 0; R < headers.length; ++R) {
          for (let C = 0; C < headers[R].length; ++C) {
            const cell_ref = XLSX.utils.encode_cell({ c: C, r: R });
            if (!ws[cell_ref]) ws[cell_ref] = { t: "s", v: "" };
            ws[cell_ref].s = mergeHeaderStyle;
          }
        }

        /* ESTILOS PARA CAMPOS DEL FORMATO */
        const valueStyles = {
          Apto: {
            fill: { fgColor: { rgb: "208454" } },
            font: { bold: true, color: { rgb: "FFFFFFFF" } },
          },
          "Con Control Específico": {
            fill: { fgColor: { rgb: "FFFFFF00" } },
            font: { bold: true },
          },
          "No Apto": {
            fill: { fgColor: { rgb: "E6423C" } },
            font: { bold: true, color: { rgb: "FFFFFFFF" } },
          },
          "N/A": {
            fill: { fgColor: { rgb: "BFBFBF" } },
            font: { color: { rgb: "000000" }, bold: true },
          },
          "No Registra": {
            fill: { fgColor: { rgb: "E6423C" } },
            font: { color: { rgb: "FFFFFF" }, bold: true },
          },
        };

        /* ASIGNAR ESTILOS A CELDAS */
        jsonData.forEach((rowData, rowIndex) => {
          const startRow = 3 + rowIndex * 4;
          for (let offset = 0; offset < 4; offset++) {
            const r = startRow + offset;
            jsonHeaders.forEach((header, colIndex) => {
              const cellRef = XLSX.utils.encode_cell({ r, c: colIndex });
              if (!ws[cellRef]) return;
              let cellStyle = { ...dataCellStyle };
              const cellValue = rowData[header];
              if (header === "imagenesVehiculo") {
                if (ws[cellRef].v !== "-") {
                  cellStyle = {
                    ...cellStyle,
                    font: {
                      ...cellStyle.font,
                      color: { rgb: "073d7a" },
                      underline: true,
                    },
                  };
                } else {
                  ws[cellRef].s = cellStyle;
                }
              } else if (offset === 0) {
                if (
                  header.includes("soat") ||
                  header.includes("tecnicoMecanica") ||
                  header.includes("licenciaConduccion") ||
                  header.includes("examen") ||
                  header.includes("capacitacion")
                ) {
                  cellStyle = {
                    ...cellStyle,
                    ...getStyleByValue(cellValue),
                  };
                } else if (header.includes("revisionComparendos")) {
                  cellStyle = {
                    ...cellStyle,
                    ...getStyleByValue(cellValue, true),
                  };
                } else if (header.endsWith("_valor")) {
                  const baseHeader = header.replace(/_valor$/, "");
                  if (dynamicHeaders.includes(baseHeader)) {
                    if (
                      cellValue === "N/A" ||
                      cellValue === "No Registra"
                    ) {
                      cellStyle = {
                        ...cellStyle,
                        ...valueStyles[cellValue],
                      };
                    } else {
                      const criterio = rowData[`${baseHeader}_criterio`];
                      if (criterio && valueStyles[criterio]) {
                        cellStyle = {
                          ...cellStyle,
                          ...valueStyles[criterio],
                        };
                      } else {
                        cellStyle = {
                          ...cellStyle,
                          ...valueStyles[cellValue],
                        };
                      }
                    }
                  }
                }
                if (header === "resultadoInspeccion") {
                  const inspectionResult = rowData[header];
                  const resultStyle =
                    stylesByInspectionResult[inspectionResult];
                  if (resultStyle) {
                    cellStyle = { ...cellStyle, ...resultStyle };
                  }
                }
              }
              ws[cellRef].s = cellStyle;
            });
          }
        });

        /* AGREGAR HOJA AL ARCHIVO PRINCIPAL */
        XLSX.utils.book_append_sheet(wb, ws, sheetName);
      });

      /* GENERAR HOJAS DE REGISTROS SIN FORMATO */
      if (registrosSinFormato.length > 0) {
        /* DEFINIR NOMBRE A LA HOJA */
        const sheetName = "INSPECCIONES NO REGISTRADAS";

        /* DEFINIR CABECERAS DE LA HOJA */
        const headers = [
          [
            "FECHA",
            "CONDUCTOR",
            "",
            "",
            "VEHÍCULO",
            "",
            "",
            "",
            "JUSTIFICACIÓN",
            "",
          ],
          [
            "",
            "NOMBRE",
            "RODAMIENTO",
            "DISPOSITIVO/CLIENTE",
            "PLACA",
            "CLASE",
            "RODAMIENTO",
            "DISPOSITIVO/CLIENTE",
            "APLICA PARA",
            "MOTIVO",
          ],
        ];

        /* AÑADIR CABECERAS A LA HOJA */
        const ws = XLSX.utils.aoa_to_sheet(headers);

        /* CONFIGURAR UNIONES DE COLUMNAS */
        ws["!merges"] = [
          /* FECHA (0) */
          { s: { r: 0, c: 0 }, e: { r: 1, c: 0 } },

          /* CONDUCTOR (1, 2, 3) */
          { s: { r: 0, c: 1 }, e: { r: 0, c: 3 } },
          { s: { r: 1, c: 1 }, e: { r: 1, c: 1 } },
          { s: { r: 1, c: 2 }, e: { r: 1, c: 2 } },
          { s: { r: 1, c: 3 }, e: { r: 1, c: 3 } },

          /* VEHÍCULO (4, 5, 6, 7) */
          { s: { r: 0, c: 4 }, e: { r: 0, c: 7 } },
          { s: { r: 1, c: 4 }, e: { r: 1, c: 4 } },
          { s: { r: 1, c: 5 }, e: { r: 1, c: 5 } },
          { s: { r: 1, c: 6 }, e: { r: 1, c: 6 } },
          { s: { r: 1, c: 7 }, e: { r: 1, c: 7 } },

          /* NOVEDAD (8, 9) */
          { s: { r: 0, c: 8 }, e: { r: 0, c: 9 } },
          { s: { r: 1, c: 8 }, e: { r: 1, c: 8 } },
          { s: { r: 1, c: 9 }, e: { r: 1, c: 9 } },
        ];

        /* CONFIGURACIÓN DE LOS DATOS  */
        const jsonData = registrosSinFormato.map((item) => {
          return {
            fecha: item.fecha,
            conductor: item.conductor.nombre,
            rodamientoConductor: item.conductor.conRodamiento,
            dispositivoZonaClienteConductor: item.conductor
              .dispositivoZonaCliente
              ? item.conductor.dispositivoZonaCliente
              : "-",
            placa: item.placa,
            clase: item.vehiculo.clase,
            rodamientoVehiculo: item.vehiculo.conRodamiento,
            dispositivoZonaClienteVehiculo: item.vehiculo
              .dispositivoZonaClienteVehiculo
              ? item.vehiculo.dispositivoZonaClienteVehiculo
              : "-",
            aplicaPara: item.novedad.aplicaPara,
            novedad: item.novedad,
          };
        });

        /* DEFINIR CABECERAS PARA JSON */
        const jsonHeaders = [
          "fecha",
          "conductor",
          "rodamientoConductor",
          "dispositivoZonaClienteConductor",
          "placa",
          "clase",
          "rodamientoVehiculo",
          "dispositivoZonaClienteVehiculo",
          "aplicaPara",
          "novedad",
        ];

        /* AÑADIR DATOS Y CABECERAS */
        XLSX.utils.sheet_add_json(ws, jsonData, {
          origin: "A3",
          header: jsonHeaders,
          skipHeader: true,
        });

        /* ASIGNAR ESTILOS A CABECERAS */
        for (let R = 0; R < headers.length; ++R) {
          for (let C = 0; C < headers[R].length; ++C) {
            const cell_ref = XLSX.utils.encode_cell({ c: C, r: R });
            if (!ws[cell_ref]) ws[cell_ref] = { t: "s", v: "" };
            ws[cell_ref].s = mergeHeaderStyle;
          }
        }

        /* ASIGNAR ESTILOS A CELDAS */
        jsonData.forEach((rowData, rowIndex) => {
          const excelRowIndex = rowIndex + 2;
          jsonHeaders.forEach((header, colIndex) => {
            const cellRef = XLSX.utils.encode_cell({
              r: excelRowIndex,
              c: colIndex,
            });
            let cellStyle = { ...dataCellStyle };
            let cellValue = rowData[header];
            if (header === "novedad") {
              if (
                typeof cellValue === "object" &&
                cellValue.id &&
                cellValue.motivo
              ) {
                const fullUrl = `${ruta}seguridadvial/novedades/consultar/${cellValue.id}`;
                ws[cellRef] = {
                  t: "s",
                  v: cellValue.motivo,
                  l: { Target: fullUrl },
                };
                cellStyle = {
                  ...cellStyle,
                  font: {
                    ...cellStyle.font,
                    color: { rgb: "073d7a" },
                    underline: true,
                  },
                };
              } else {
                ws[cellRef] = { t: "s", v: cellValue.motivo };
              }
            }
            if (ws[cellRef]) {
              ws[cellRef].s = cellStyle;
            }
          });
        });

        /* DETERMINAR ANCHO DE LAS CELDAS */
        ws["!cols"] = [
          { wch: 15 }, // FECHA
          { wch: 40 }, // CONDUCTOR - NOMBRE
          { wch: 25 }, // CONDUCTOR - RODAMIENTO
          { wch: 35 }, // CONDUCTOR - DISPOSITIVO/CLIENTE
          { wch: 25 }, // VEHÍCULO - PLACA
          { wch: 20 }, // VEHÍCULO - CLASE
          { wch: 25 }, // VEHÍCULO - RODAMIENTO
          { wch: 35 }, // VEHÍCULO - DISPOSITIVO/CLIENTE
          { wch: 40 }, // NOVEDAD - APLICA PARA
          { wch: 40 }, // NOVEDAD - MOTIVO
        ];

        /* AGREGAR HOJA AL ARCHIVO PRINCIPAL */
        XLSX.utils.book_append_sheet(wb, ws, sheetName);
      }

      /* GENERAR ARCHIVO */
      XLSX.writeFile(
        wb,
        `${nombre
          ? nombre + " (Formato Completo)"
          : "Historial de Inspecciones (Formato Completo)"
        }.xlsx`,
      );
    },
    descargarExcelSencillo(rows, nombre) {
      const XLSX = require("sheetjs-style");
      let wb = XLSX.utils.book_new();

      /* CONFIGURAR CABECERAS */
      const headers = [
        [
          "FECHA",
          "REGISTRO",
          "DECLARACIÓN DE VERACIDAD",
          "RODAMIENTO DE INSPECCIÓN",
          "TIPO DE INSPECCIÓN",
          "RESULTADO DE INSPECCIÓN",
          "REALIZADA POR",
          "CONDUCTOR",
          "",
          "",
          "VEHÍCULO",
          "",
          "",
          "",
          "",
          "JUSTIFICACIÓN",
          "",
          "DOCUMENTOS DE VEHÍCULO",
          "",
          "",
          "DOCUMENTOS DE CONDUCTOR",
          "",
          "",
          "",
        ],
        [
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "NOMBRE",
          "RODAMIENTO",
          "DISPOSITIVO/CLIENTE",
          "PLACA",
          "CLASE",
          "IMÁGENES",
          "RODAMIENTO",
          "DISPOSITIVO/CLIENTE",
          "APLICA PARA",
          "MOTIVO",
          "SOAT",
          "TÉCNICO MECÁNICA",
          "REVISIÓN DE COMPARENDOS",
          "LICENCIA DE CONDUCCIÓN",
          "EXAMEN",
          "CAPACITACIÓN",
          "REVISIÓN DE COMPARENDOS",
        ],
      ];

      /* AÑADIR CABECERAS A LA HOJA */
      const ws = XLSX.utils.aoa_to_sheet(headers);

      /* CONFIGURAR UNIONES DE COLUMNAS */

      /* COLUMNAS SIMPLES (1, 2, 3, 4, 5, 6, 7) */
      const staticVerticalMerges = Array.from({ length: 7 }, (_, c) => ({
        s: { r: 0, c },
        e: { r: 1, c },
      }));

      /* UNIÓN DE CONDUCTOR (7, 8, 9) */
      const conductorHorizontal = {
        s: { r: 0, c: 7 },
        e: { r: 0, c: 9 },
      };
      const conductorVertical = [
        { s: { r: 1, c: 7 }, e: { r: 1, c: 7 } },
        { s: { r: 1, c: 8 }, e: { r: 1, c: 8 } },
        { s: { r: 1, c: 9 }, e: { r: 1, c: 9 } },
      ];

      /* UNIÓN DE VEHÍCULO (10, 11, 12, 13, 14) */
      const vehiculoHorizontal = {
        s: { r: 0, c: 10 },
        e: { r: 0, c: 14 },
      };
      const vehiculoVertical = [
        { s: { r: 1, c: 10 }, e: { r: 1, c: 10 } },
        { s: { r: 1, c: 11 }, e: { r: 1, c: 11 } },
        { s: { r: 1, c: 12 }, e: { r: 1, c: 12 } },
        { s: { r: 1, c: 13 }, e: { r: 1, c: 13 } },
        { s: { r: 1, c: 14 }, e: { r: 1, c: 14 } },
      ];

      /* UNIÓN DE NOVEDAD (15, 16) */
      const novedadHorizontal = {
        s: { r: 0, c: 15 },
        e: { r: 0, c: 16 },
      };
      const novedadVertical = [
        { s: { r: 1, c: 15 }, e: { r: 1, c: 15 } },
        { s: { r: 1, c: 16 }, e: { r: 1, c: 16 } },
      ];

      /* UNIÓN DE DOCUMENTOS DEL VEHÍCULO (17, 18, 19) */
      const docsVehiculoHorizontal = {
        s: { r: 0, c: 17 },
        e: { r: 0, c: 19 },
      };
      const docsVehiculoVertical = Array.from({ length: 3 }, (_, i) => ({
        s: { r: 1, c: 17 + i },
        e: { r: 1, c: 17 + i },
      }));

      /* UNIÓN DE DOCUMENTOS DEL CONDUCTOR (20, 21, 22, 23) */
      const docsConductorHorizontal = {
        s: { r: 0, c: 20 },
        e: { r: 0, c: 23 },
      };
      const docsConductorVertical = Array.from({ length: 4 }, (_, i) => ({
        s: { r: 1, c: 20 + i },
        e: { r: 1, c: 20 + i },
      }));

      /* UNIÓN FINAL */
      ws["!merges"] = [
        ...staticVerticalMerges,
        conductorHorizontal,
        ...conductorVertical,
        vehiculoHorizontal,
        ...vehiculoVertical,
        novedadHorizontal,
        ...novedadVertical,
        docsVehiculoHorizontal,
        ...docsVehiculoVertical,
        docsConductorHorizontal,
        ...docsConductorVertical,
      ];

      /* CONFIGURACIÓN DE LOS DATOS */
      const jsonData = rows.map((item) => {
        const {
          vehiculo,
          conductor,
          fecha,
          registro,
          esRodamiento,
          tipo,
          resultado,
          realizadaPor,
        } = item;
        const soat = !vehiculo.documentos
          ? "-"
          : vehiculo.documentos.idSoat
            ? "Si"
            : "No";
        const tecnicoMecanica = !vehiculo.documentos
          ? "-"
          : vehiculo.documentos.idTecnicoMecanica
            ? "Si"
            : "No";
        const revisionComparendosVehiculo = !vehiculo.documentos
          ? "-"
          : vehiculo.documentos.idRevision
            ? "Si"
            : "No";
        const licenciaConduccion = !conductor.documentos
          ? "-"
          : conductor.documentos.idLicencia
            ? "Si"
            : "No";
        const examen = !conductor.documentos
          ? "-"
          : conductor.documentos.idExamen
            ? "Si"
            : "No";
        const capacitacion = !conductor.documentos
          ? "-"
          : conductor.documentos.idCapacitacion
            ? "Si"
            : "No";
        const revisionComparendosConductor = !conductor.documentos
          ? "-"
          : conductor.documentos.idRevision
            ? "Si"
            : "No";

        return {
          fecha,
          registro,
          esRodamiento,
          tipoInspeccion: tipo,
          resultadoInspeccion: resultado,
          declaracionVeracidad: item.declaracionVeracidad,
          realizadaPor,
          conductor: conductor.nombre,
          rodamientoConductor: conductor.conRodamiento,
          dispositivoZonaClienteConductor: conductor.dispositivoZonaCliente
            ? conductor.dispositivoZonaCliente
            : "-",
          placa: item.placa,
          clase: vehiculo?.clase || "N/A",
          imagenesVehiculo:
            vehiculo.imagenes.length > 0
              ? vehiculo.imagenes.map((item) => item.url)
              : "-",
          rodamientoVehiculo: vehiculo.conRodamiento,
          dispositivoZonaClienteVehiculo: vehiculo.dispositivoZonaCliente
            ? vehiculo.dispositivoZonaCliente
            : "-",
          aplicaPara: item.novedad ? item.novedad.aplicaPara : "N/A",
          novedad: item.novedad ? item.novedad : "N/A",
          soat,
          tecnicoMecanica,
          revisionComparendosVehiculo,
          licenciaConduccion,
          examen,
          capacitacion,
          revisionComparendosConductor,
        };
      });

      /* DEFINIR CABECERAS PARA JSON */
      const jsonHeaders = [
        "fecha",
        "registro",
        "declaracionVeracidad",
        "esRodamiento",
        "tipoInspeccion",
        "resultadoInspeccion",
        "realizadaPor",
        "conductor",
        "rodamientoConductor",
        "dispositivoZonaClienteConductor",
        "placa",
        "clase",
        "imagenesVehiculo",
        "rodamientoVehiculo",
        "dispositivoZonaClienteVehiculo",
        "aplicaPara",
        "novedad",
        "soat",
        "tecnicoMecanica",
        "revisionComparendosVehiculo",
        "licenciaConduccion",
        "examen",
        "capacitacion",
        "revisionComparendosConductor",
      ];
      const imagenesColIndex = jsonHeaders.indexOf("imagenesVehiculo");
      const filasDatos = [];
      const mergesDatos = [];
      const linksToSet = [];
      let baseRow = 2;
      jsonData.forEach((row) => {
        // NORMALIZAR ARREGLO DE IMÁGENES A 4 POSICIONES
        const imagenes = Array.isArray(row.imagenesVehiculo)
          ? row.imagenesVehiculo.slice(0, 4)
          : [];

        while (imagenes.length < 4) imagenes.push("");

        // CREAR 4 FILAS PARA ESTE REGISTRO
        imagenes.forEach((imgUrl, subIndex) => {
          const fila = jsonHeaders.map((header, colIndex) => {
            if (header === "imagenesVehiculo") {
              if (imgUrl) {
                const etiqueta = `Imagen #${subIndex + 1}`;
                linksToSet.push({
                  r: baseRow + subIndex,
                  c: colIndex,
                  url: imgUrl,
                  texto: etiqueta,
                });
                return etiqueta;
              }
              return "-";
            }
            return subIndex === 0 ? row[header] ?? "" : "";
          });
          filasDatos.push(fila);
        });

        // FUSIONAR TODAS LAS COLUMNAS DEL REGISTRO EXCEPTO IMÁGENES
        jsonHeaders.forEach((header, colIndex) => {
          if (colIndex === imagenesColIndex) return;
          mergesDatos.push({
            s: { r: baseRow, c: colIndex },
            e: { r: baseRow + 3, c: colIndex },
          });
        });

        baseRow += 4;
      });

      // ESCRIBIR DATOS
      XLSX.utils.sheet_add_aoa(ws, filasDatos, { origin: "A3" });

      // AÑADIR MERGES A DATOS EXISTENTES
      ws["!merges"] = [...(ws["!merges"] || []), ...mergesDatos];

      // APLICAR HIPERVÍNCULOS A CADA CELDA DE IMAGEN
      linksToSet.forEach(({ r, c, url, texto }) => {
        const cellRef = XLSX.utils.encode_cell({ r, c });
        if (!ws[cellRef]) ws[cellRef] = { t: "s", v: texto };
        ws[cellRef].l = { Target: url };
      });

      /* DEFINIR ANCHO DE LAS COLUMNAS */
      ws["!cols"] = [
        { wch: 15 }, // FECHA
        { wch: 20 }, // REGISTRO
        { wch: 30 }, // DECLARACIÓN DE VERACIDAD
        { wch: 30 }, // RODAMIENTO DE INSPECCIÓN
        { wch: 25 }, // TIPO DE INSPECCIÓN
        { wch: 30 }, // RESULTADO DE INSPECCIÓN
        { wch: 40 }, // REALIZADA POR
        { wch: 40 }, // CONDUCTOR - NOMBRE
        { wch: 25 }, // CONDUCTOR - RODAMIENTO
        { wch: 35 }, // CONDUCTOR - DISPOSITIVO/CLIENTE
        { wch: 25 }, // VEHICULO - PLACA
        { wch: 25 }, // VEHICULO - CLASE
        { wch: 25 }, // VEHICULO - IMÁGENES
        { wch: 25 }, // VEHÍCULO - RODAMIENTO
        { wch: 35 }, // VEHICULO - DISPOSITIVO/CLIENTE
        { wch: 40 }, // NOVEDAD - APLICA PARA
        { wch: 40 }, // NOVEDAD - MOTIVO
        { wch: 30 }, // DOCUMENTOS VEHICULO - SOAT
        { wch: 25 }, // DOCUMENTOS VEHICULO - TECNICO MECANICA
        { wch: 35 }, // DOCUMENTOS VEHICULO - REVISIÓN DE COMPARENDOS
        { wch: 35 }, // DOCUMENTOS CONDUCTOR - LICENCIA DE CONDUCCIÓN
        { wch: 30 }, // DOCUMENTOS CONDUCTOR - EXAMEN
        { wch: 30 }, // DOCUMENTOS CONDUCTOR - CAPACITACIÓN
        { wch: 35 }, // DOCUMENTOS CONDUCTOR - REVISIÓN DE COMPARENDOS
      ];

      /* ESTILOS DE CABERCERAS */
      const mergeHeaderStyle = {
        font: {
          bold: true,
          sz: 12,
          name: "Calibri",
          color: { rgb: "F3F3F3" },
        },
        alignment: {
          wrapText: true,
          horizontal: "center",
          vertical: "center",
        },
        fill: { fgColor: { rgb: "073d7a" } },
        border: {
          top: { style: "thin", color: { rgb: "FFFFFF" } },
          bottom: { style: "thin", color: { rgb: "FFFFFF" } },
          left: { style: "thin", color: { rgb: "FFFFFF" } },
          right: { style: "thin", color: { rgb: "FFFFFF" } },
        },
      };

      /* ESTILOS DE CELDAS */

      /* GENERAL */
      const dataCellStyle = {
        border: {
          top: { style: "thin", color: 1 },
          bottom: { style: "thin", color: 1 },
          left: { style: "thin", color: 1 },
          right: { style: "thin", color: 1 },
        },
        font: {
          name: "Arial",
          sz: 10,
          bold: false,
        },
        alignment: {
          wrapText: true,
          horizontal: "center",
          vertical: "center",
        },
      };

      /* ESTILOS BASE PARA SI Y NO */
      const yesStyle = {
        fill: { fgColor: { rgb: "208454" } },
        font: { bold: true, color: { rgb: "FFFFFFFF" } },
      };

      const noStyle = {
        fill: { fgColor: { rgb: "E6423C" } },
        font: { bold: true, color: { rgb: "FFFFFFFF" } },
      };

      /* ESTILOS PARA RESULTADOS DE INSPECCIÓN */
      const stylesByInspectionResult = {
        Apto: {
          fill: { fgColor: { rgb: "208454" } },
          font: { bold: true, color: { rgb: "FFFFFFFF" } },
        },
        "Con Control Específico": {
          fill: { fgColor: { rgb: "FFFFFF00" } },
          font: { bold: true },
        },
        "No Apto": {
          fill: { fgColor: { rgb: "E6423C" } },
          font: { bold: true, color: { rgb: "FFFFFFFF" } },
        },
      };

      /* FUNCION PARA DETERMINAR COLOR DE SI Y NO */
      function getStyleByValue(value, isComparendo = false) {
        if (isComparendo) {
          if (value === "-") {
            return value;
          } else {
            return value.toLowerCase() === "no" ? yesStyle : noStyle;
          }
        } else {
          if (value === "-") {
            return value;
          } else {
            return value.toLowerCase() === "si" ? yesStyle : noStyle;
          }
        }
      }

      /* ASIGNAR ESTILOS A CABECERAS */
      for (let R = 0; R < headers.length; ++R) {
        for (let C = 0; C < headers[R].length; ++C) {
          const cell_ref = XLSX.utils.encode_cell({ c: C, r: R });
          if (!ws[cell_ref]) ws[cell_ref] = { t: "s", v: "" };
          ws[cell_ref].s = mergeHeaderStyle;
        }
      }

      /* ASIGNAR ESTILOS A CELDAS */
      jsonData.forEach((rowData, rowIndex) => {
        const startRow = 2 + rowIndex * 4;
        for (let offset = 0; offset < 4; offset++) {
          const r = startRow + offset;
          jsonHeaders.forEach((header, colIndex) => {
            const cellRef = XLSX.utils.encode_cell({ r, c: colIndex });
            if (!ws[cellRef]) return;
            let cellStyle = { ...dataCellStyle };
            let cellValue = rowData[header];
            if (header === "imagenesVehiculo") {
              if (ws[cellRef].v !== "-") {
                cellStyle = {
                  ...cellStyle,
                  font: {
                    ...cellStyle.font,
                    color: { rgb: "073d7a" },
                    underline: true,
                  },
                };
              } else {
                ws[cellRef].s = cellStyle;
              }
            } else if (offset === 0) {
              if (
                header.includes("soat") ||
                header.includes("tecnicoMecanica") ||
                header.includes("licenciaConduccion") ||
                header.includes("examen") ||
                header.includes("capacitacion")
              ) {
                cellStyle = { ...cellStyle, ...getStyleByValue(cellValue) };
              } else if (header.includes("revisionComparendos")) {
                cellStyle = {
                  ...cellStyle,
                  ...getStyleByValue(cellValue, true),
                };
              }
              if (header === "resultadoInspeccion") {
                const inspectionResult = rowData[header];
                const resultStyle =
                  stylesByInspectionResult[inspectionResult];
                if (resultStyle) {
                  cellStyle = { ...cellStyle, ...resultStyle };
                }
              }
              if (header === "novedad") {
                if (
                  typeof cellValue === "object" &&
                  cellValue.id &&
                  cellValue.motivo
                ) {
                  const fullUrl = `${ruta}seguridadvial/novedades/consultar/${cellValue.id}`;
                  ws[cellRef] = {
                    t: "s",
                    v: cellValue.motivo,
                    l: { Target: fullUrl },
                  };
                  cellStyle = {
                    ...cellStyle,
                    font: {
                      ...cellStyle.font,
                      color: { rgb: "073d7a" },
                      underline: true,
                    },
                  };
                } else {
                  ws[cellRef] = {
                    t: "s",
                    v: cellValue.motivo ? cellValue.motivo : cellValue,
                  };
                }
              }
            }
            ws[cellRef].s = cellStyle;
          });
        }
      });

      /* IMPRIMIR EXCEL */
      XLSX.utils.book_append_sheet(wb, ws, "INSPECCIONES");

      /* GENERAR ARCHIVO */
      XLSX.writeFile(
        wb,
        `${nombre
          ? nombre + " (Formato Sencillo)"
          : "Historial de Inspecciones (Formato Sencillo)"
        }.xlsx`,
      );
    },
  },
};

// INSPECCION - EXENTOS
export const inspeccionExento = {
  objeto: class {
    constructor() {
      return {
        id: "",
        idEmpresa: "",
        usuarios: [],
        registro: {
          idUsuario: "",
          estado: "Creado",
          creacion: serverTimestamp(),
          actualizacion: serverTimestamp(),
          filtro: moment().format("YYYY-MM-DD")
        }
      }
    }
  },
  funciones: {
    async crear(exento, modoSinConexion) {
      if (modoSinConexion) {
        const registros = await localforage.getItem(
          colecciones.localforage.seguridadVial.inspecciones.exentos.registros,
        );
        const copia = Array.isArray(registros)
          ? JSON.parse(JSON.stringify(registros))
          : [];
        const lista = copia.concat([exento]);
        await localforage.setItem(
          colecciones.localforage.seguridadVial.inspecciones.exentos.registros,
          lista,
        );
      } else {
        await setDoc(
          doc(
            db,
            colecciones.firebase.seguridadVial.inspecciones.exentos.registros,
            exento.id,
          ),
          exento,
        );
      }
    },
    async actualizar(exento, modoSinConexion) {
      if (modoSinConexion) {
        const registros = await localforage.getItem(
          colecciones.localforage.seguridadVial.inspecciones.exentos.registros,
        );
        const index = Array.isArray(registros)
          ? registros.findIndex((reg) => reg && reg.id === exento.id)
          : -1;
        if (index !== -1) {
          registros[index] = exento;
          await localforage.setItem(
            colecciones.localforage.seguridadVial.inspecciones.exentos.registros,
            registros,
          );
        }
      } else {
        await updateDoc(
          doc(
            db,
            colecciones.firebase.seguridadVial.inspecciones.exentos.registros,
            exento.id,
          ),
          exento,
        );
      }
    },
    async obtener(id, modoSinConexion) {
      if (modoSinConexion) {
        const registros = await localforage.getItem(
          colecciones.localforage.seguridadVial.inspecciones.exentos.registros,
        );
        if (Array.isArray(registros)) {
          const encontrado = registros.find(
            (reg) =>
              reg &&
              reg.id === id &&
              reg.registro &&
              ["Creado", "Editado"].includes(reg.registro.estado),
          );
          return encontrado || null;
        }
        return null;
      } else {
        const q = query(
          collection(
            db,
            colecciones.firebase.seguridadVial.inspecciones.exentos.registros,
          ),
          where("id", "==", id),
          where("registro.estado", "in", ["Creado", "Editado"]),
        );
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs.length > 0
          ? querySnapshot.docs[0].data()
          : null;
      }
    },
    async obtenerPorIdEmpresa(idEmpresa, modoSinConexion) {
      if (!idEmpresa) return null;
      if (modoSinConexion) {
        const registros = await localforage.getItem(
          colecciones.localforage.seguridadVial.inspecciones.exentos.registros,
        );
        if (Array.isArray(registros)) {
          const encontrado = registros.find(
            (reg) =>
              reg &&
              reg.idEmpresa === idEmpresa &&
              reg.registro &&
              ["Creado", "Editado"].includes(reg.registro.estado),
          );
          return encontrado || null;
        }
        return null;
      } else {
        const q = query(
          collection(
            db,
            colecciones.firebase.seguridadVial.inspecciones.exentos.registros,
          ),
          where("idEmpresa", "==", idEmpresa),
          where("registro.estado", "in", ["Creado", "Editado"]),
        );
        const querySnapshot = await getDocs(q);
        return querySnapshot.docs.length > 0
          ? querySnapshot.docs[0].data()
          : null;
      }
    },
    async generarID() {
      const refExento = doc(
        collection(
          db,
          colecciones.firebase.seguridadVial.inspecciones.exentos.registros,
        ),
      );
      return refExento.id;
    },
  }
};
